import styled from "styled-components";

const CheckBoxLabelDiv = styled.div`
  display: flex;
  justify-content: center;
`;
export default CheckBoxLabelDiv;
